<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/basic/user',title:'系统管理'},{title:'系统附件'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="文件名称">
							    <el-input v-model="q.name"></el-input>
							</el-form-item>
							<el-form-item label="保存类型">
							    <el-input v-model="q.savetype"></el-input>
							</el-form-item>
							<el-form-item label="保存目录">
							    <el-input v-model="q.saveurl"></el-input>
							</el-form-item>
							<el-form-item label="文件类型">
							    <el-input v-model="q.filetype"></el-input>
							</el-form-item>
						</div>
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="业务类型">
										<el-input v-model="q.reftype"></el-input>
									</el-form-item>
									<el-form-item label="业务主键">
										<el-input v-model="q.refid"></el-input>
									</el-form-item>
									<el-form-item label="可用标志">
										<el-input v-model="q.delflag"></el-input>
									</el-form-item>
								</div>
							</div>
						</el-collapse-transition>
                    </el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
						</div>
					</div>
                </div>
            </div>
            <div class="h-table h-mrt30">
                <el-table
                    ref="ddtable"
                    :data="tableData"
                    stripe
					border
                    style="width: 100%"
                    >
                <el-table-column
                        type="index"
                        label="#"
                        width="40">
                </el-table-column>
                    <el-table-column
                            prop="name"
                            label="文件名称"
                            width="260"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="reftype"
                            label="业务类型"
                            width="160"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="refid"
                            label="业务主键"
                            width="180"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="savetype"
                            label="保存类型"
                            width="90"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="saveurl"
                            label="保存录几个"
                            min-width="260"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="filetype"
                            label="文件类型"
                            width="110"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="delflag"
                            label="可用标志"
                            width="90"
                            :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            {{scope.row.delflag|dictname('shifou_keyong')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="cucode"
                            label="创建人id"
                            width="110"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="cuname"
                            label="创建人"
                            width="80"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="cdate"
                            label="创建时间"
                            width="160"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="lucode"
                            label="更新人id"
                            width="150"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="ldate"
                            label="最后更新时间"
                            width="160"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="filesize"
                            label="文件大小"
                            width="90"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        label="操作"
                        width="80"
                        >
                        <template slot-scope="scope">
                            <el-button
                                class="h-tableLink h-btn"
                                @click="opendia(scope.row)"
                                >
                                编辑
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                    <pagination :page="q" @query="query" />
                </div>
            </div>
        </div>
        <div>
            <el-dialog 
				 :close-on-click-modal="false"
                :visible.sync="dialogFormVisible" 
                v-if="dialogFormVisible"  
                class="h-dialog2"
                >
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>更新业务附件</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLine" style="padding:20px;height:400px;overflow: scroll">
                    <brupload
                        :refid="refid"
                        :reftype="reftype"
                        uploadflag
                        delflag
                        />
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    export default {
        components: {},
        data() {
            return {// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                //查询属性
                dialogFormVisible:false,
                refid:null,
                reftype:null,
                q: {
                    pageSize:10,
                    pageNo:1,
                    total:0,
                },
                //表单
                f:{
                    id:null,
                    name:null,
                    savetype:null,
                    saveurl:null,
                    filetype:null,
                    reftype:null,
                    refid:null,
                    delflag:null,
                    cucode:null,
                    cuname:null,
                    cdate:null,
                    lucode:null,
                    ldate:null,
                    filesize:null,
                },
                //table列表
                tableData: [],
                //操作标志
                optflag:'save',
            }
        },
        created() {
            this.query();
        },
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
            query(p) {
                ss.FileService.page(this.q).then(rd=>{
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            handleFilter() {
                this.query();
            },
            opendia(o){
                console.log(o)
                this.refid = o.refid;
                this.reftype = o.reftype;
                this.dialogFormVisible = true;
            },
        }
    }
</script>
